import { useMutation } from "@tanstack/react-query";
import { commonServices } from "./common.services";

export const useCreateStaffRole = () => {
  return useMutation({
    mutationFn: commonServices.createStaffRole,
  });
};

export const useUpdateStaffRole = () => {
  return useMutation({
    mutationFn: commonServices.updateStaffRole,
  });
};

export const useDeleteStaffRole = () => {
  return useMutation({
    mutationFn: commonServices.deleteStaffRole,
  });
};
